var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeoWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16675 16.666C13.3089 16.666 16.6667 13.3082 16.6667 9.16602C16.6667 5.02388 13.3089 1.66602 9.16675 1.66602C5.02461 1.66602 1.66675 5.02388 1.66675 9.16602C1.66675 13.3082 5.02461 16.666 9.16675 16.666Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.775 17.2413C16.2167 18.5747 17.225 18.708 18 17.5413C18.7084 16.4747 18.2417 15.5997 16.9584 15.5997C16.0084 15.5913 15.475 16.333 15.775 17.2413Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeoWhite);
export default __webpack_public_path__ + "static/media/seo-white.c9a3a12caed923a5c6ee2893a005a49d.svg";
export { ForwardRef as ReactComponent };